import { render, staticRenderFns } from "./GradientPoint.vue?vue&type=template&id=462645b7&"
import script from "./GradientPoint.vue?vue&type=script&lang=ts&"
export * from "./GradientPoint.vue?vue&type=script&lang=ts&"
import style0 from "./GradientPoint.vue?vue&type=style&index=0&id=462645b7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports